import { getHomeUrl } from '@celito.clients/utils';
import React from 'react';
import { useNavigate } from 'react-router';

import { FooterData } from '../../layouts/mock';
import { PageNotFoundProps } from './page-not-found.model';
import PageNotFoundView from './page-not-found.view';

const PageNotFoundController: React.FC<PageNotFoundProps> = (props) => {
  const navigate = useNavigate();

  const handleNagivate = () => {
    navigate(getHomeUrl());
  };

  return (
    <PageNotFoundView
      onNavigate={handleNagivate}
      footerData={FooterData}
      showFooter={props?.showFooter ?? true}
    />
  );
};

export default PageNotFoundController;
